const initializeClaimAnimations = () => {
    const animations = document.querySelectorAll('.claim-animation');
    if (!animations) return;

    animations.forEach(animation => {
        const words = animation.querySelector('.claim-animation__words');
        const timeout = parseInt(words.dataset.timeout, 10);
        const speed = parseInt(words.dataset.speed, 10);
        const wordElements = Array.from(animation.querySelectorAll('.claim-animation__word'));
        const totalWords = wordElements.length;
        const visibleWordsCount = 5;
        const lineHeight = window.getComputedStyle(wordElements[0]).lineHeight;
        animation.dataset.lineHeightFloat = parseFloat(lineHeight.replace('px', ''));
        let centeredIndex = Math.floor(visibleWordsCount / 2);
        let currentIndex = 0;

        animation.style.setProperty('--claim-number-of-words', visibleWordsCount);
        animation.style.setProperty('--claim-word-height', lineHeight);

        const cloneWords = () => {
            const fragment = document.createDocumentFragment();
            wordElements.forEach(word => {
                const clone = word.cloneNode(true);
                fragment.appendChild(clone);
            });
            words.appendChild(fragment);
        };

        const highlightCenteredWord = () => {
            const allWordElements = Array.from(animation.querySelectorAll('.claim-animation__word'));
            allWordElements.forEach(word => word.classList.remove('centered'));
            allWordElements[(currentIndex + centeredIndex) % totalWords].classList.add('centered');
            allWordElements[((currentIndex + centeredIndex) % totalWords) + totalWords].classList.add('centered');
        };

        const scrollWords = () => {
            currentIndex++;
            words.style.transition = `transform ${speed}ms ease`;

            if (currentIndex === totalWords + 1) {
                currentIndex = 0;
                words.style.transition = 'none';
                words.style.transform = `translateY(0)`;

                setTimeout(() => {
                    words.style.transition = `transform ${speed}ms ease`;
                    scrollWords();
                }, speed);
            } else {
                words.style.transform = `translateY(-${currentIndex * animation.dataset.lineHeightFloat}px)`;
                highlightCenteredWord();
                setTimeout(scrollWords, timeout);
            }
        };

        cloneWords();
        highlightCenteredWord();
        ref = setTimeout(scrollWords, timeout);
    });

    window.addEventListener('resize', e => {
        animations.forEach(animation => {
            const lineHeight = window.getComputedStyle(animation.querySelector('.claim-animation__word')).lineHeight;
            animation.dataset.lineHeightFloat = parseFloat(lineHeight.replace('px', ''));
            animation.style.setProperty('--claim-word-height', lineHeight);
        })
    }, {
        passive: true
    });
};

initializeClaimAnimations();
